import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { getImageUrl, getPlaceholder } from '../../api';
import { Loader } from '../../components/Shared';

export default function DashboardPage() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard').then(r => setData(r.data.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;
  const { stats = {}, recent_projects = [], recent_messages = [] } = data || {};

  const topCards = [
    { value: stats.projects,        label: 'Total Projects',  icon: 'bi-building',  color: '#B8860B', bg: '#FDF6E3' },
    { value: stats.services,        label: 'Active Services', icon: 'bi-tools',     color: '#2980B9', bg: '#EBF4FD' },
    { value: stats.unread_messages, label: 'Unread Messages', icon: 'bi-envelope',  color: '#DC3545', bg: '#FDECEA', link: '/admin/messages' },
    { value: stats.total_views,     label: 'Total Views',     icon: 'bi-eye',       color: '#28A745', bg: '#D4EDDA' },
  ];

  const miniCards = [
    { label: 'Published',     value: stats.published,    icon: 'bi-check-circle',    color: '#28A745' },
    { label: 'Ongoing',       value: stats.ongoing,      icon: 'bi-hourglass-split', color: '#FFC107' },
    { label: 'Completed',     value: stats.completed,    icon: 'bi-trophy',          color: '#2980B9' },
    { label: 'Testimonials',  value: stats.testimonials, icon: 'bi-chat-quote',      color: '#9B59B6' },
  ];

  return (
    <div style={{ overflowX: 'hidden' }}>
      <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
        <div>
          <h2 style={{ fontFamily: 'var(--font-display)', color: 'var(--text)', marginBottom: 4 }}>Dashboard</h2>
          <p style={{ color: 'var(--text-muted)', margin: 0, fontSize: '0.875rem' }}>Overview of your construction portfolio</p>
        </div>
        <Link to="/admin/projects" className="btn-primary-styled" style={{ fontSize: '0.875rem' }}>
          <i className="bi bi-plus-lg" /> New Project
        </Link>
      </div>

      {/* Top stat cards */}
      <div className="row g-3 mb-4">
        {topCards.map((c, i) => (
          <div key={i} className="col-sm-6 col-xl-3">
            <div className="stat-card">
              <div className="stat-icon" style={{ background: c.bg }}>
                <i className={`bi ${c.icon}`} style={{ color: c.color }} />
              </div>
              <div>
                <div className="stat-value">{(c.value || 0).toLocaleString()}</div>
                <div className="stat-label">{c.label}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Mini cards */}
      <div className="row g-3 mb-5">
        {miniCards.map((s, i) => (
          <div key={i} className="col-6 col-md-3">
            <div className="admin-card p-4 text-center">
              <i className={`bi ${s.icon}`} style={{ color: s.color, fontSize: 22, marginBottom: 8, display: 'block' }} />
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.7rem', fontWeight: 700, color: 'var(--text)' }}>{s.value || 0}</div>
              <div style={{ fontSize: 11, letterSpacing: 1.5, textTransform: 'uppercase', color: 'var(--text-muted)', marginTop: 4 }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        {/* Recent Projects */}
        <div className="col-lg-7">
          <div className="admin-card" style={{ overflow: 'hidden' }}>
            <div style={{ padding: '18px 22px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h6 style={{ color: 'var(--text)', margin: 0, fontWeight: 600 }}>Recent Projects</h6>
              <Link to="/admin/projects" style={{ color: 'var(--gold-dark)', fontSize: '0.8rem', fontWeight: 600 }}>View All →</Link>
            </div>
            <div>
              {recent_projects.length === 0 ? (
                <div style={{ padding: 24, color: 'var(--text-muted)', textAlign: 'center', fontSize: '0.875rem' }}>No projects yet</div>
              ) : recent_projects.map(p => (
                <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid var(--bg-3)', minWidth: 0 }}>
                  <div style={{ width: 46, height: 36, borderRadius: 6, overflow: 'hidden', flexShrink: 0, background: 'var(--bg-3)' }}>
                    <img
                      src={p.thumbnail ? getImageUrl('projects', p.thumbnail) : getPlaceholder(80, 60, '')}
                      alt=""
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={e => e.target.src = getPlaceholder(80, 60, '')}
                    />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: '0.875rem', color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.title}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 3, flexWrap: 'wrap' }}>
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.72rem' }}>{new Date(p.created_at).toLocaleDateString()}</span>
                      <span className={p.status === 'completed' ? 'badge-success-light' : p.status === 'ongoing' ? 'badge-warning-light' : 'badge-secondary-light'}
                        style={{ fontSize: '0.68rem', padding: '1px 7px' }}>
                        {p.status}
                      </span>
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: 3 }}>
                        <i className="bi bi-eye" style={{ fontSize: 10 }} />{p.views || 0}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Recent Messages */}
        <div className="col-lg-5">
          <div className="admin-card" style={{ overflow: 'hidden' }}>
            <div style={{ padding: '18px 22px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h6 style={{ color: 'var(--text)', margin: 0, fontWeight: 600 }}>
                Recent Messages
                {stats.unread_messages > 0 && (
                  <span style={{ background: '#DC3545', color: '#fff', fontSize: 10, padding: '2px 7px', borderRadius: 10, marginLeft: 8 }}>
                    {stats.unread_messages}
                  </span>
                )}
              </h6>
              <Link to="/admin/messages" style={{ color: 'var(--gold-dark)', fontSize: '0.8rem', fontWeight: 600 }}>View All →</Link>
            </div>
            <div>
              {recent_messages.length === 0 ? (
                <div style={{ padding: 24, color: 'var(--text-muted)', textAlign: 'center', fontSize: '0.875rem' }}>No messages yet</div>
              ) : recent_messages.map(m => (
                <div key={m.id} style={{ padding: '13px 16px', borderBottom: '1px solid var(--bg-3)', display: 'flex', alignItems: 'flex-start', gap: 10, minWidth: 0 }}>
                  {!m.is_read && (
                    <div style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--gold)', marginTop: 6, flexShrink: 0 }} />
                  )}
                  <div style={{ flex: 1, minWidth: 0, marginLeft: m.is_read ? 17 : 0 }}>
                    <div style={{ fontWeight: m.is_read ? 500 : 700, fontSize: '0.875rem', color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.name}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.subject || m.email}</div>
                    <div style={{ color: 'var(--text-light)', fontSize: '0.7rem', marginTop: 2 }}>{new Date(m.created_at).toLocaleDateString()}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
